import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from '@/pages/Landing';
import Dashboard from '@/pages/Dashboard';
import PurchasePage from '@/pages/PurchasePage';
import PurchaseSuccess from '@/pages/PurchaseSuccess';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import MarketingHub from '@/pages/MarketingHub';
import { ThemeProvider } from '@/components/ThemeProvider';
import { Toaster } from '@/components/ui/sonner';
import MaintenanceBanner from '@/components/MaintenanceBanner';

// Maintenance mode flag - set to false when ready for production
export const MAINTENANCE_MODE = true;

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="cryptopulse-theme">
      <div className="App">
        {MAINTENANCE_MODE && <MaintenanceBanner />}
        <Toaster position="top-right" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/purchase" element={<PurchasePage />} />
            <Route path="/purchase/success" element={<PurchaseSuccess />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/marketing" element={<MarketingHub />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;